module.exports = __webpack_public_path__ + "static/media/home-hero.1dc17e09.jpg";